import { render, staticRenderFns } from "./SaveComponentGroupButton.vue?vue&type=template&id=4ef8e099&scoped=true"
import script from "./SaveComponentGroupButton.vue?vue&type=script&lang=js"
export * from "./SaveComponentGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8e099",
  null
  
)

export default component.exports